





















import { Component, Vue } from 'vue-property-decorator';
import { Work as WorkInterface } from 'portfolio';
import SmoothScrolling from '@/utils/SmoothScrolling';
import WorkItem from '@/components/WorkItem.vue';

@Component({
  components: {
    WorkItem,
  },
})
export default class Work extends Vue {
  siteUrl: string = `${process.env.VUE_APP_SITE_URL}${process.env.BASE_URL}`
  works: WorkInterface[] = require('@/data/work.json')


  created() {
    this.fetchWorks();
  }

  async fetchWorks(): Promise<void> {
    // NOTE: Removed as it breaks the SmoothScrolling initialization.
    // try {
    //   const r = await fetch(`${this.siteUrl}work.json`, {
    //     method: 'GET',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   });
    //   const data = await r.json();
    //   this.works = data as WorkInterface[];
    // } catch(e) {
    //   console.error(e);
    // }
  }
}
